import { Link } from 'react-router-dom';

export default function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-foreground-900 text-background-50/70">
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-14">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10">
          <div>
            <div className="flex items-center gap-2 mb-4">
              <div className="w-7 h-7 flex items-center justify-center">
                <i className="ri-cpu-line text-lg text-primary-400"></i>
              </div>
              <span className="font-heading font-semibold text-sm text-background-50 tracking-wide">
                CoreNext 算力研究院
              </span>
            </div>
            <p className="text-xs leading-relaxed text-background-50/50">
              专注于超大规模并行计算处理器技术研究与分析，为AI训练、科学计算与数据中心领域提供深度技术洞察。
            </p>
          </div>

          <div>
            <h4 className="font-heading font-semibold text-xs text-background-50 mb-4 tracking-wide uppercase">
              <a href="#quick-links">快速链接</a>
            </h4>
            <ul className="flex flex-col gap-2">
              <li>
                <Link to="/" className="text-xs text-background-50/50 hover:text-primary-400 transition-colors whitespace-nowrap">
                  首页
                </Link>
              </li>
              <li>
                <Link to="/categories" className="text-xs text-background-50/50 hover:text-primary-400 transition-colors whitespace-nowrap">
                  分类浏览
                </Link>
              </li>
              <li>
                <Link to="/about" className="text-xs text-background-50/50 hover:text-primary-400 transition-colors whitespace-nowrap">
                  关于我们
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="font-heading font-semibold text-xs text-background-50 mb-4 tracking-wide uppercase">
              <a href="#categories">文章分类</a>
            </h4>
            <ul className="flex flex-col gap-2">
              <li>
                <Link to="/categories?cat=tech-architecture" className="text-xs text-background-50/50 hover:text-primary-400 transition-colors whitespace-nowrap">
                  技术架构
                </Link>
              </li>
              <li>
                <Link to="/categories?cat=ai-chips" className="text-xs text-background-50/50 hover:text-primary-400 transition-colors whitespace-nowrap">
                  AI芯片
                </Link>
              </li>
              <li>
                <Link to="/categories?cat=industry-solutions" className="text-xs text-background-50/50 hover:text-primary-400 transition-colors whitespace-nowrap">
                  行业方案
                </Link>
              </li>
              <li>
                <Link to="/categories?cat=performance-optimization" className="text-xs text-background-50/50 hover:text-primary-400 transition-colors whitespace-nowrap">
                  性能优化
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="font-heading font-semibold text-xs text-background-50 mb-4 tracking-wide uppercase">
              <a href="#contact">联系方式</a>
            </h4>
            <ul className="flex flex-col gap-2 text-xs text-background-50/50">
              <li className="flex items-start gap-2">
                <div className="w-4 h-4 flex items-center justify-center mt-0.5">
                  <i className="ri-mail-line text-primary-400"></i>
                </div>
                <span>contact@corenext-tech.com</span>
              </li>
              <li className="flex items-start gap-2">
                <div className="w-4 h-4 flex items-center justify-center mt-0.5">
                  <i className="ri-phone-line text-primary-400"></i>
                </div>
                <span>+86-10-8888-6666</span>
              </li>
              <li className="flex items-start gap-2">
                <div className="w-4 h-4 flex items-center justify-center mt-0.5">
                  <i className="ri-map-pin-line text-primary-400"></i>
                </div>
                <span>北京市海淀区中关村科技园</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-12 pt-6 border-t border-background-50/10 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-background-50/40">
            &copy; {currentYear} CoreNext 算力研究院. All rights reserved.
          </p>
          <div className="flex items-center gap-4">
            <a
              href="https://github.com"
              target="_blank"
              rel="nofollow noopener noreferrer"
              className="w-5 h-5 flex items-center justify-center text-background-50/40 hover:text-primary-400 transition-colors"
            >
              <i className="ri-github-fill"></i>
            </a>
            <a
              href="https://twitter.com"
              target="_blank"
              rel="nofollow noopener noreferrer"
              className="w-5 h-5 flex items-center justify-center text-background-50/40 hover:text-primary-400 transition-colors"
            >
              <i className="ri-twitter-x-fill"></i>
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}